/**
 * @name 알림설정
 * @description
 */
import styled from 'styled-components'
import {App} from 'template'
import {Panel} from 'components'
// contents
import {Header} from './common'
import {Form} from './contents'

export default function Presenter() {
  return (
    <App>
      <Content className="container-height">
        <Panel header={<Header />} padding="24px">
          {/* 폼영역 */}
          {/* <Form /> */}
        </Panel>
      </Content>
    </App>
  )
}
//*--------------------------------------------------*
const Content = styled.div`
  /*--------------*/
`
